import React from 'react';
import { Helmet } from 'react-helmet';
import Subpoena from 'component/subpoena';

import { Title, Container } from './subpoena.styles';

function SubpoenaPage() {
  return (
    <>
      <Helmet>
        <title>Página de Integração com Intimações AASP</title>
        <meta
          name="description"
          content="Listagem de intimações da AASP no Juslabore"
        />
      </Helmet>
      <Container>
        <Title>Intimações AASP</Title>

        <Subpoena />
      </Container>
    </>
  );
}

export default SubpoenaPage;
